import { render, staticRenderFns } from "./OrgReviews.vue?vue&type=template&id=1f74fa1b&scoped=true&"
import script from "./OrgReviews.vue?vue&type=script&lang=js&"
export * from "./OrgReviews.vue?vue&type=script&lang=js&"
import style0 from "./OrgReviews.vue?vue&type=style&index=0&id=1f74fa1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74fa1b",
  null
  
)

export default component.exports